import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CollectionsService } from './collections.abstract.service';
import { Collection } from './collections.model';

@Injectable()
export class CollectionsServiceImpl implements CollectionsService {
    private baseUrl: string = environment.API_GATEWAY_URL;

    constructor(@Inject('HTTP_CLIENT') public http: HttpClient) {}

    public getCollections(): Observable<Collection[]> {
        return this.http.get(`${this.baseUrl}/service-state/admin/collect`).pipe(map((r) => r as Collection[]));
    }

    public getCollection(id: string): Observable<Collection> {
        return this.http.get(`${this.baseUrl}/service-state/admin/collect/${id}`).pipe(map((response) => response as Collection));
    }

    public createCollection(payload: any): Observable<Collection> {
        return this.http.post(`${this.baseUrl}/service-state/admin/collect`, payload).pipe(map((response) => response as Collection));
    }

    public updateCollection(payload: any): Observable<Collection> {
        return this.http.patch(`${this.baseUrl}/service-state/admin/collect/${payload._id}`, payload).pipe(map((response) => response as Collection));
    }

    public duplicateCollection(id: string): Observable<Collection> {
        return this.http.post(`${this.baseUrl}/service-state/admin/collect/${id}/copy`, {}).pipe(map((response) => response as Collection));
    }

    public deleteCollection(id: string): Observable<any> {
        return this.http.delete(`${this.baseUrl}/service-state/admin/collect/${id}`).pipe(map((response) => response as any));
    }
}

export const COLLECTIONS_SERVICE_PROVIDER = {
    provide: CollectionsService,
    useClass: CollectionsServiceImpl,
};
